export const environment = {
	production: true,
	apiUrl: 'http://keyskills-main-frontend:3000/v1',
	showFeatureDev: false,
	frontEndUrl: 'https://playskills.it'
};
